/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Language options for video data streams (audio/subtitles).
 * Used to identify available language tracks.
 */
export enum VideoDataStreamLanguage {
  /**
   * Language is not applicable or not specified.
   */
  NOT_APPLICABLE = "NOT_APPLICABLE",

  /**
   * English language track.
   */
  ENGLISH = "ENGLISH",

  /**
   * Spanish language track.
   */
  SPANISH = "SPANISH"
}
